<template>
    <div class="rows">
        <div style="margin-bottom: 10px;">
            <table class="table-border-none">
                <tr>
                    <td style="padding-left: 0;">Číslo:</td>
                    <td><input v-model="item.cisloZakazky" style="width: 200px;" /><span class="required">*</span></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Název:</td>
                    <td><input v-model="item.nazev" style="width: 400px;" /><span class="required">*</span></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Investor:</td>
                    <td><input v-model="item.investor" style="width: 400px;" /></td>
                </tr>
                <tr>
                    <td style="padding-left: 0; vertical-align: top;">Osoby investora:</td>
                    <td>
                        <select v-model="this.investorOsoba" style="width: 375px;">
                            <option :value="-1">&lt; vyberte osobu investora &gt;</option>
                            <option v-for="(o, i) in sortedInvestor" :key="i" :value="o.id">{{ o.prijmeni + ' ' + o.jmeno + ' (' + o.email + ')' }}</option>
                        </select>
                        <span @click="addItemIO" class="selectListButton" style="margin-left: 2px;">+</span>
                        <div class="selectList">
                            <div v-for="(io, i) in item.investorOsoby" :key="i" class="selectListItem">
                                <span @click="removeItemIO(io.id)" class="selectListButton">-</span>
                                {{ io.prijmeni + ' ' + io.jmeno + ' (' + io.email + ')' }}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Editor zakázky:</td>
                    <td>
                        <select v-model="item.idEditor" style="width: 400px;">
                            <option :value="-1">&lt; vyberte editora zakázky &gt;</option>
                            <option v-for="(man, i) in sortedEditor" :key="i" :value="man.id">{{ man.prijmeni + ' ' + man.jmeno + ' (' + man.email + ')' }}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Manažer zakázky:</td>
                    <td>
                        <select v-model="item.idManager" style="width: 400px;">
                            <option :value="-1">&lt; vyberte manažera zakázky &gt;</option>
                            <option v-for="(man, i) in sortedManazer" :key="i" :value="man.id">{{ man.prijmeni + ' ' + man.jmeno + ' (' + man.email + ')' }}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td style="padding-left: 0; vertical-align: top;">Projektanti:</td>
                    <td>
                        <select v-model="this.projektantOsoba" style="width: 375px;">
                            <option :value="-1">&lt; vyberte projektanta &gt;</option>
                            <option v-for="(p, i) in sortedProjektant" :key="i" :value="p.id">{{ p.prijmeni + ' ' + p.jmeno + ' (' + p.email + ')' }}</option>
                        </select>
                        <span @click="addItemP" class="selectListButton" style="margin-left: 2px;">+</span>
                        <div class="selectList">
                            <div v-for="(po, i) in item.projektantOsoby" :key="i" class="selectListItem">
                                <span @click="removeItemP(po.id)" class="selectListButton">-</span>
                                {{ po.prijmeni + ' ' + po.jmeno + ' (' + po.email + ')' }}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td style="padding-left: 0; vertical-align: top;">Odpovědné osoby:</td>
                    <td>
                        <select v-model="this.odpovednaOsoba" style="width: 375px;">
                            <option :value="-1">&lt; vyberte odpovědnou osobu &gt;</option>
                            <option v-for="(o, i) in sortedUzivatel" :key="i" :value="o.id">{{ o.prijmeni + ' ' + o.jmeno + ' (' + o.email + ')' }}</option>
                        </select>
                        <span @click="addItemOO" class="selectListButton" style="margin-left: 2px;">+</span>
                        <div class="selectList">
                            <div v-for="(oo, i) in item.odpovedneOsoby" :key="i" class="selectListItem">
                                <span @click="removeItemOO(oo.id)" class="selectListButton">-</span>
                                {{ oo.prijmeni + ' ' + oo.jmeno + ' (' + oo.email + ')' }}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-left: 0;">
                        <input type="checkbox" v-model="item.notifikacePodani" />Notifikace pro podání
                        <input type="checkbox" v-model="item.notifikaceStanoviska" style="margin-left: 20px;" />Notifikace pro stanoviska
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-left: 0;">
                        <input type="radio" id="aktivni" v-bind:value="0" v-model="item.stav" :disabled="!this.isAdmin" />Aktivní
                        <input type="radio" id="neaktivni" v-bind:value="1" v-model="item.stav" :disabled="!this.isAdmin" style="margin-left: 20px;" />Neaktivní
                        <input type="radio" id="archivovane" v-bind:value="2" v-model="item.stav" :disabled="!this.isAdmin" style="margin-left: 20px;" />Archivováno
                    </td>
                </tr>
            </table>
        </div>
        <div class="cols" style="gap: 10px; margin-top: 20px;">
            <button @click="saveItem">Uložit</button>
            <button @click="close">Zavřít</button>
            <button v-if="itemId !== -1" @click="deleteItem">Smazat</button>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import _ from 'lodash'

    export default {
        name: 'EditZakazka',
        props: ['itemId', 'isAdmin'],
        data() {
            return {
                item: {
                    'id': -1,
                    'cisloZakazky': '',
                    'nazev': '',
                    'idInvestor': -1,
                    'investor': '',
                    'idEditor': -1,
                    'idManager': -1,
                    'odpovedneOsoby': [],
                    'investorOsoby': [],
                    'projektantOsoby': []
                },
                investor: [],
                uzivatel: [],
                odpovednaOsoba: -1,
                investorOsoba: -1,
                projektantOsoba: -1
            }
        },
        computed: {
            sortedInvestor_old() {
                return _.orderBy(this.investor, 'nazev')
            },
            sortedUzivatel() {
                return this.uzivatel
                    .slice()
                    .filter(u => u.idRole === 1 || u.idRole === 2)
                    .sort((a, b) => (a.prijmeni + ':' + a.jmeno).localeCompare((b.prijmeni + ':' + b.jmeno), 'cz'))
            },
            sortedManazer() {
                return this.uzivatel
                    .slice()
                    .filter(u => u.idRole === 2 || u.idRole === 3)
                    .sort((a, b) => (a.prijmeni + ':' + a.jmeno).localeCompare((b.prijmeni + ':' + b.jmeno), 'cz'))
            },
            sortedInvestor() {
                return this.uzivatel
                    .slice()
                    .filter(u => u.idRole === 4)
                    .sort((a, b) => (a.prijmeni + ':' + a.jmeno).localeCompare((b.prijmeni + ':' + b.jmeno), 'cz'))
            },
            sortedProjektant() {
                return this.uzivatel
                    .slice()
                    .filter(u => u.idRole === 6)
                    .sort((a, b) => (a.prijmeni + ':' + a.jmeno).localeCompare((b.prijmeni + ':' + b.jmeno), 'cz'))
            },
            sortedEditor() {
                return this.uzivatel
                    .slice()
                    .filter(u => u.idRole === 2)
                    .sort((a, b) => (a.prijmeni + ':' + a.jmeno).localeCompare((b.prijmeni + ':' + b.jmeno), 'cz'))
            }
        },
        methods: {
            load() {
                this.$progress.start()
                api.getDOSS()
                .then(response => {
                    this.$progress.finish()
                    this.investor = response.data
                })
                .catch(error => { 
                    this.$progress.finish()
                    console.log('Error: ', error)
                })
                
                this.$progress.start()
                api.getUzivatel()
                .then(response => {
                    this.$progress.finish()
                    this.uzivatel = response.data
                })
                .catch(error => { 
                    this.$progress.finish()
                    console.log('Error: ', error)
                })

                if (this.itemId === -1) {
                    this.item = {
                        'id': -1,
                        'cisloZakazky': '',
                        'nazev': '',
                        'idInvestor': -1,
                        'investor': '',
                        'idEditor': -1,
                        'idManager': -1,
                        'odpovedneOsoby': [],
                        'investorOsoby': [],
                        'projektantOsoby': []
                    }
                }
                else {
                    this.$progress.start()
                    api.getZakazkaById(this.itemId)
                    .then(response => {
                        this.$progress.finish()
                        this.item = response.data
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                    })
                }
            },
            close() {
                this.$emit('close')
            },
            saveItem() {
                if (confirm('Uložit záznam?')) {
                    if (this.item.nazev.length === 0 || this.item.cisloZakazky.length === 0) {
                        alert('Záznam nebude uložen. Povinná pole jsou: Číslo zakázky, Název')
                        return
                    }
                    else {
                        if (this.item.id === -1) {
                            this.$progress.start()
                            api.postZakazka(this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                                this.$emit('close')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                        else {
                            this.$progress.start()
                            api.putZakazka(this.item.id, this.item)
                            .then(() => {
                                this.$progress.finish()

                                if (this.item.stav == 2) {
                                    if (confirm('VAROVÁNÍ! Zakázka bude exportována, archivována a všechny její nahrané soubory smazány. Pokračovat?')) {
                                        window.open(process.env.VUE_APP_API_URL + '/Export/archive?id=' + this.item.id)
                                    }
                                }
                                
                                this.$emit('updateTable')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                    }
                }
            },
            deleteItem() {
                if (confirm('VAROVÁNÍ! Tuto akci nelze vzít zpátky. Opravdu chcete smazat tuto zakázku a všechny její podání?')) {
                    this.$progress.start()
                    api.deleteZakazka(this.item.id)
                    .then(() => {
                        this.$progress.finish()
                        this.$emit('updateTable')
                        this.$emit('close')
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                        alert('Nastala chyba při mazání. Záznam nebyl smazán.')
                    })
                }
            },
            removeItemOO(id) {
                this.item.odpovedneOsoby = this.item.odpovedneOsoby.filter(oo => oo.id !== id)
            },
            addItemOO() {
                if (this.odpovednaOsoba === -1) return
                if (this.item.odpovedneOsoby.filter(oo => oo.id === this.odpovednaOsoba).length > 0) return
                this.item.odpovedneOsoby.push(this.uzivatel.filter(u => u.id === this.odpovednaOsoba)[0])
            },
            removeItemIO(id) {
                this.item.investorOsoby = this.item.investorOsoby.filter(oo => oo.id !== id)
            },
            addItemIO() {
                if (this.investorOsoba === -1) return
                if (this.item.investorOsoby.filter(oo => oo.id === this.investorOsoba).length > 0) return
                this.item.investorOsoby.push(this.uzivatel.filter(u => u.id === this.investorOsoba)[0])
            },
            removeItemP(id) {
                this.item.projektantOsoby = this.item.projektantOsoby.filter(p => p.id !== id)
            },
            addItemP() {
                if (this.projektantOsoba === -1) return
                if (this.item.projektantOsoby.filter(p => p.id === this.projektantOsoba).length > 0) return
                this.item.projektantOsoby.push(this.uzivatel.filter(u => u.id === this.projektantOsoba)[0])
            },
        },
        created() {
            this.load()
        },
        beforeUpdate() {
            if (this.itemId !== this.item.id) {
                this.load()
            }
        }
    }
</script>